module["exports"] = [
  "#####",
  "####",
  "###",
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/building_number.js
// module id = 1466
// module chunks = 0